import { render } from "./ArcheryResults.vue?vue&type=template&id=6881086c&scoped=true"
import script from "./ArcheryResults.vue?vue&type=script&lang=js"
export * from "./ArcheryResults.vue?vue&type=script&lang=js"

import "./ArcheryResults.vue?vue&type=style&index=0&id=6881086c&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6881086c"]])

export default __exports__